export default __webpack_public_path__ + "static/media/infusion-buret.35390880.jpg";